import script from "./Standard-Title.vue?vue&type=script&setup=true&lang=js"
export * from "./Standard-Title.vue?vue&type=script&setup=true&lang=js"

import "./Standard-Title.vue?vue&type=style&index=0&id=5d2196ea&lang=css"

const __exports__ = script;

export default __exports__